<script setup>
import { useI18n } from "vue-i18n";
import ItemGamePopup from "@/components/v2/popup/ItemGamePopup.vue";
import HomePopup from "@/components/v2/popup/homePopup/HomePopup.vue";
import NoticeBoard from "@/components/v2/board/NoticeBoard.vue";
import FaqBoard from "@/components/v2/board/FaqBoard.vue";
import MainSlider from "@/components/v2/home/MainSlider.vue";
import GameList from "@/components/v2/home/GameList.vue";
import { onOpenSports } from "@/components/v2/header/common";

// i18n 초기화
useI18n();
</script>
<template>
  <HomePopup />
  <ItemGamePopup />
  <div class="wraper-root">
    <main class="wrapper" id="games-section">
      <!-- Slider Section -->
      <MainSlider />

      <!-- Casino Grid -->
      <GameList
        id="casino-section"
        :title="$t('homePage.casino.title')"
        :sub-title="$t('homePage.casino.subtitle')"
        list-name="casinoList"
        :type="1"
      />

      <!-- Slot Grid -->
      <GameList
        id="slotgame-section"
        :title="$t('homePage.slot.title')"
        :sub-title="$t('homePage.slot.subtitle')"
        list-name="slotGameList"
        :type="2"
      />

      <!-- FAQ, Notice -->
      <section class="wptb-faq-one pd-top-more p-0 pt-5">
        <div class="container">
          <div class="wptb-faq--inner">
            <div class="row">
              <FaqBoard />
              <NoticeBoard />
            </div>
          </div>
        </div>
      </section>

      <!-- footer banner-->
      <div class="wptb-funfacts-one" v-if="$store.state.settings.isSportsOn">
        <div class="container">
          <div class="wptb-image-single mb-4 d-inline-block wow fadeInUp">
            <div class="wptb-item--inner">
              <button class="wptb-item--image" @click="onOpenSports($store)">
                <img src="/assets/img/more/banner_sports.png" alt="img" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" name="datacode" class="datacode" value="0" />
    </main>
  </div>
</template>
<style scoped></style>
